module.exports = {"411423100":"城关镇","411423101":"张弓镇","411423102":"柳河镇","411423103":"逻岗镇","411423104":"石桥镇","411423105":"黄岗镇","411423106":"华堡镇","411423203":"刘楼乡","411423204":"程楼乡","411423205":"乔楼乡","411423206":"城郊乡","411423207":"阳驿乡","411423209":"孔集乡","411423210":"赵村乡","411423400":"产业集聚区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411423.json
// module id = 1657
// module chunks = 0